import React from "react";
import {
  Card,
  Text,
  Textarea,
  Button,
  Avatar,
  Group,
  Stack,
  Divider,
  ScrollArea,
  Box,
} from "@mantine/core";

interface Comment {
  id: number;
  author: string;
  avatarColor: string;
  time: string;
  text: string;
}

interface Status {
  author: string;
  avatarColor: string;
  time: string;
  title: string;
  message: string;
  comments: Comment[];
}

const sampleStatus: Status = {
  author: "Nellie Maxwell",
  avatarColor: "blue",
  time: "3 hours ago",
  title: "Internet Not Working for Last 2 Days",
  message:
    "On the other hand, if the Internet doesn't work on other devices too, then the problem is most likely with the router or the Internet connection itself",
  comments: [
    {
      id: 1,
      author: "Zoe Wright",
      avatarColor: "teal",
      time: "1 hour ago",
      text: "One good way to fix the router is to restart it.",
    },
    {
      id: 2,
      author: "Diane Fisher",
      avatarColor: "red",
      time: "1 hour ago",
      text: "Turn on the modem and one minute later turn on the router.",
    },
  ],
};

export function TicketChat() {
  return (
    <Card radius="md" shadow="sm" style={{ width: 360 }}>
      <Stack spacing="md">
        <Box>
          <Textarea
            placeholder="Post"
            autosize
            minRows={2}
            styles={{
              input: { resize: "none", backgroundColor: "#f5f5f5" },
            }}
          />
          <Group position="right" mt="xs">
            <Button size="sm">Sent</Button>
          </Group>
        </Box>
        <Divider />

        <Card.Section px="md" py="sm">
          <Group spacing="sm">
            <Avatar color={sampleStatus.avatarColor} radius="xl">
              {sampleStatus.author
                .split(" ")
                .map((n) => n[0])
                .join("")}
            </Avatar>
            <Stack spacing={0} style={{ flex: 1 }}>
              <Group position="apart">
                <Text weight={500}>{sampleStatus.author}</Text>
                <Text size="xs" color="dimmed">
                  {sampleStatus.time}
                </Text>
              </Group>
              <Text weight={600}>{sampleStatus.title}</Text>
              <Text size="sm" mt="xs">
                {sampleStatus.message}
              </Text>
            </Stack>
          </Group>
        </Card.Section>
        <Card.Section>
          <Divider />
          <ScrollArea style={{ height: 200, padding: "0 16px" }}>
            {sampleStatus.comments.map((c) => (
              <Group key={c.id} align="flex-start" mt="sm">
                <Avatar color={c.avatarColor} radius="xl" size="sm">
                  {c.author
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </Avatar>
                <Box style={{ flex: 1 }}>
                  <Group position="apart">
                    <Text size="sm" weight={500}>
                      {c.author}
                    </Text>
                    <Text size="xs" color="dimmed">
                      {c.time}
                    </Text>
                  </Group>
                  <Text size="sm" mt={2}>
                    {c.text}
                  </Text>
                </Box>
              </Group>
            ))}
          </ScrollArea>
        </Card.Section>
        <Box>
          <Textarea
            placeholder="Reply"
            autosize
            minRows={1}
            styles={{ input: { resize: "none", backgroundColor: "#f5f5f5" } }}
          />
        </Box>
      </Stack>
    </Card>
  );
}
